import { render, staticRenderFns } from "./FrameContainer.vue?vue&type=template&id=61f0b6e4"
import script from "./FrameContainer.vue?vue&type=script&lang=ts"
export * from "./FrameContainer.vue?vue&type=script&lang=ts"
import style0 from "./FrameContainer.vue?vue&type=style&index=0&id=61f0b6e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports